import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import * as React from 'react';
import { IMiaRouteMatchResponse } from '../components/hooks';
import { HeaderButton } from './HeaderButton';
import { HeaderTitle } from './HeaderTitle';
import { DRAWER_WIDTH } from './layoutConstants';
import { SidebarIcon } from './SidebarIcon';
import { UserActionAvatar } from './UserActionAvatar';

interface IHeaderProps {
  onDrawerClick: () => any;
  matchingRoutes: IMiaRouteMatchResponse | null;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      marginLeft: DRAWER_WIDTH,
      position: 'absolute',
      [theme.breakpoints.up('md')]: {
        width: `calc(100% - ${DRAWER_WIDTH}px)`
      }
    },
    navIconHide: {
      [theme.breakpoints.up('md')]: {
        display: 'none'
      }
    }
  })
);

let Header: React.FunctionComponent<IHeaderProps> = ({ onDrawerClick, matchingRoutes }) => {
  const classes = useStyles();

  return (
    <AppBar className={classes.appBar}>
      <Toolbar>
        <IconButton aria-label="open drawer" color="inherit" onClick={onDrawerClick} className={classes.navIconHide}>
          <MenuIcon />
        </IconButton>
        <HeaderTitle matchingRoute={matchingRoutes?.currentRoute} />
        <HeaderButton>{matchingRoutes?.currentRoute?.route?.filterComponent}</HeaderButton>
        <HeaderButton>
          {matchingRoutes?.currentRoute?.route?.searchComponent ?? matchingRoutes?.rootRoute?.route.searchComponent}
        </HeaderButton>
        <SidebarIcon>
          {matchingRoutes?.currentRoute?.route?.sidebar?.icon ?? matchingRoutes?.rootRoute?.route?.sidebar?.icon}
        </SidebarIcon>
        <UserActionAvatar />
      </Toolbar>
    </AppBar>
  );
};

Header = React.memo<IHeaderProps>(Header);
export { Header };
